// Firebase initialization for the web app
// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyBpG0ibRYw62vpSMwk8O_MJk3ShsiwsQFg',
  authDomain: 'somethingcomicalslop.firebaseapp.com',
  projectId: 'somethingcomicalslop',
  storageBucket: 'somethingcomicalslop.appspot.com',
  messagingSenderId: '676991618293',
  appId: '1:676991618293:web:5aa53992bba462653349bc',
  measurementId: 'G-ZPD0DP8PQQ'
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics (in browsers where supported) - skip on localhost to reduce noise
let analytics = null;
try {
  if (typeof window !== 'undefined' && window.location.hostname !== 'localhost' && window.location.protocol === 'https:') {
    analytics = getAnalytics(app);
  }
} catch (_) {
  // No-op if analytics isn't available (e.g., non-HTTPS, unsupported browser)
}

export { app, analytics };
// Firestore database for app data (e.g., forums)
const db = getFirestore(app);
export { db };
// Export Storage for uploads (e.g., profile pictures)
const storage = getStorage(app);
export { storage };
// Export Functions for admin operations
const functions = getFunctions(app);
try {
  if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
    connectFunctionsEmulator(functions, 'localhost', 5001);
  }
} catch (_) {
  // no-op
}
export { functions };

// Optional: Initialize App Check to satisfy Firebase App Check enforcement for Storage/Firestore
// In development on localhost, enable debug token mode automatically.
let appCheck = null;
try {
  if (typeof window !== 'undefined') {
    const isLocal = window.location.hostname === 'localhost';
    const isR2WorkerConfigured = !!(
      typeof process !== 'undefined' && process.env && process.env.REACT_APP_AVATAR_R2_WORKER_URL
    );
    const cloudName = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_CLOUDINARY_CLOUD_NAME)
      || (typeof window !== 'undefined' && window.localStorage && localStorage.getItem('CLD_CLOUD_NAME'))
      || '';
    const uploadPreset = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET)
      || (typeof window !== 'undefined' && window.localStorage && localStorage.getItem('CLD_UPLOAD_PRESET'))
      || '';
    const isCloudinaryConfigured = !!(cloudName && uploadPreset);
    const disableAppCheck = !!(
      typeof process !== 'undefined' && process.env && process.env.REACT_APP_DISABLE_APPCHECK === 'true'
    );
    if (isLocal) {
      // If Cloudinary is handling uploads in dev, skip App Check entirely to avoid noisy 403 logs
      if (!isCloudinaryConfigured) {
        try {
          // If a fixed debug token is provided via env, use it; otherwise ask SDK to generate and log one
          const pinned = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_APPCHECK_DEBUG_TOKEN)
            ? process.env.REACT_APP_APPCHECK_DEBUG_TOKEN
            : true;
          window.FIREBASE_APPCHECK_DEBUG_TOKEN = pinned;
        } catch (_) {}
      }
    }
    const siteKey = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_RECAPTCHA_V3_SITE_KEY)
      ? process.env.REACT_APP_RECAPTCHA_V3_SITE_KEY
      : undefined;
    // Initialize App Check only when needed and not explicitly disabled:
    // - On localhost when Cloudinary AND R2 Worker are NOT configured (we still need Storage access)
    // - On non-localhost when a real siteKey is provided
    const shouldInitAppCheck = !disableAppCheck && ((isLocal && !isCloudinaryConfigured && !isR2WorkerConfigured) || (!isLocal && !!siteKey));
    try {
      // Minimal diagnostics to help debug env/behavior in dev tools
      if (isLocal) {
        console.info('[AppCheck] local dev:', {
          isCloudinaryConfigured,
          isR2WorkerConfigured,
          disableAppCheck,
          siteKeyPresent: !!siteKey,
          willInit: shouldInitAppCheck,
        });
      }
    } catch (_) {}
    if (shouldInitAppCheck) {
      appCheck = initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider(siteKey || 'local-dev'),
        isTokenAutoRefreshEnabled: true,
      });
    } else {
      try { if (isLocal) console.info('[AppCheck] Skipped initialization on localhost'); } catch (_) {}
    }
  }
} catch (e) {
  // App Check is optional; ignore initialization errors in unsupported contexts
}
export { appCheck };
